(function () {
  class HookController {
    constructor() {
      this._animPool = [];
      this._animsCreated = 0;

      this._layoutComplete = false;

      this._reelDistance = 192;
      this._rowDistance = 162;
      this._symbolStart = 880;

      this._hookAnims = ["Drop Top", "Drop Mid", "Drop Btm"];

      this._crtHooks = [];
      this._crtAnims = [];

      messageBus.subscribe("startHook", this.doHook.bind(this));
      messageBus.subscribe("spinner:GameConfigEvent", this.onGameConfigEvent.bind(this));

      Reflex.registerEventHandler("resize", this.onOrientationChange.bind(this));
    }

    onGameConfigEvent() {
      this._container = resourceManager.get("hookContainer");
      this._mask = resourceManager.get("hookMask");
      this._logo = resourceManager.get("postReels:logoContainerLandscape");

      this._container.mask = this._mask;

      this._mask.beginFill(0xffffff);
      this._mask.lineStyle(0, 0xffffff);
      this._mask.drawRect(0, 0, 1, 1);
      this._mask.scale.x = 1100;
      this._mask.scale.y = 610;

      this._layoutComplete = true;
    }

    doHook(task) {
      musicManager.hookStart();

      this._crtHooks = [];

      const hookData = task.data.hook;
      const currentSymbols = task.data.currentSymbols;

      gsap.to(this._logo, {
        duration: 0.5,
        alpha: 0,
      });

      const symbols = hookData.newScatters;
      const lastSymbol = symbols[symbols.length - 1].reel;

      for (let i = 0; i < 5; i++) {
        const ignore = currentSymbols.find((element) => element.cell.reel === i);

        if (!ignore) {
          const hasCaught = symbols.find((element) => element.reel === i);

          const reel = i;
          const row = hasCaught?.row ?? 0;

          const anim = this.getAnim();
          const hook = anim.hook;
          hook.x = reel * this._reelDistance;

          this._crtHooks.push({
            hook,
            xPos: reel * this._reelDistance,
          });

          const symbol = anim.symbol;
          const symbolPos = helpers.getSymbolPos(reel, row);
          symbol.x = symbolPos.x;
          symbol.y = this._symbolStart;
          symbol.visible = false;

          const scale = resourceManager.get("slotContainer").scale;
          symbol.scale = scale;

          hook.visible = true;

          hook.play("Intro", false, 0, () => {
            hook.play("loop", false, 0, () => {
              if (hasCaught) {
                this.animateSymbol(symbol, reel, row);
              }

              hook.play(this._hookAnims[row], false, 0, () => {
                hook.visible = false;
                symbol.visible = false;
                this._animPool.push(anim);

                if (hasCaught) {
                  const reelSlot = resourceManager.get("slotContainer:reelContainer:reel" + reel);
                  reelSlot.setReelSymbol(row, 17);
                }

                if (reel === lastSymbol) {
                  messageBus.post("hookComplete");

                  this._crtHooks = [];
                  this._crtAnims = [];

                  musicManager.hookEnd();

                  gsap.to(this._logo, {
                    duration: 0.5,
                    alpha: 1,
                  });
                }
              });
            });
          });
        }
      }
    }

    animateSymbol(symbol, reel, row) {
      const ease = row === 0 ? "back.out(0.5)" : "back.out(1.5)";

      const symbolPos = helpers.getSymbolPos(reel, row);
      const scale = resourceManager.get("slotContainer").scale;

      const anim = gsap
        .timeline()
        .call(() => {
          symbol.scale = scale;
          symbol.x = symbolPos.x;
          symbol.y = this._symbolStart;
          symbol.visible = true;
        })
        .to(symbol, {
          duration: 0.8,
          delay: 0.3,
          y: symbolPos.y,
          ease,
        });

      this._crtAnims.push({
        anim,
        symbol,
        coord: { reel, row },
      });
    }

    getAnim() {
      let anim = undefined;

      if (this._animPool.length > 0) {
        anim = this._animPool.pop();
      } else {
        const hook = resourceManager.createObject("spine", "hook" + this._animsCreated, "hookContainer:hooks", {
          name: "Hook",
          defaultAnimation: "Intro",
          scaleX: 1,
          scaleY: 1,
        });

        const symbol = resourceManager.createObject("sprite", "symbol" + this._animsCreated, "hookContainer:symbols", {
          fileName: "Symbols/Bonus/Bonus_00000.png",
          anchor: 0.5,
        });

        anim = { hook, symbol };

        this._animsCreated++;
      }
      return anim;
    }

    onOrientationChange() {
      if (!this._layoutComplete) return;

      this._mask.scale.x = 1100;
      this._mask.scale.y = 610;

      this._crtHooks.forEach((hook) => {
        hook.hook.x = hook.xPos;
      });

      const scale = resourceManager.get("slotContainer").scale;
      const cont = resourceManager.get("hookContainer");

      this._crtAnims.forEach((anim) => {
        const pos = helpers.getSymbolPos(anim.coord.reel, anim.coord.row);
        anim.anim.pause();
        anim.symbol.x = pos.x - cont.x;
        anim.symbol.y = pos.y - cont.y;
        anim.symbol.scale = scale;
        anim.symbol.visible = true;
      });
    }
  }

  new HookController();
})();
